module.exports = __webpack_public_path__ + "img/distribution-icon.ef4e309c.svg";